
import { Question } from '../types';

export const taj101MakharijQuestions: Question[] = [
  {
    id: 'taj031',
    text: 'What is the literal meaning of "makhārij"?',
    type: 'single',
    options: [
      { id: 'a', text: 'Places from which something exits', isCorrect: true },
      { id: 'b', text: 'Ways of pronunciation', isCorrect: false },
      { id: 'c', text: 'Qualities of sounds', isCorrect: false },
      { id: 'd', text: 'Rules of recitation', isCorrect: false }
    ],
    explanation: 'Makhārij is the plural of makhraj. It literally means places from which something exits. Technically, it refers to articulation points, i.e., those places from which the sounds of the letters are articulated.',
    topic: 'taj101'
  },
  {
    id: 'taj032',
    text: 'According to Khalīl Ibn Aḥmad al-Farāhīdī, how many makhārij (articulation points) are there?',
    type: 'single',
    options: [
      { id: 'a', text: '17 makhārij', isCorrect: true },
      { id: 'b', text: '14 makhārij', isCorrect: false },
      { id: 'c', text: '28 makhārij', isCorrect: false },
      { id: 'd', text: '10 makhārij', isCorrect: false }
    ],
    explanation: 'According to Khalīl Ibn Aḥmad al-Farāhīdī, there are 17 makhārij (articulation points). This is also the view held by Ibn al-Jazarī and most contemporary scholars.',
    topic: 'taj101'
  },
  {
    id: 'taj033',
    text: 'From which makhraj (articulation point) are the three letters of madd pronounced?',
    type: 'single',
    options: [
      { id: 'a', text: 'The empty space in the mouth and throat', isCorrect: true },
      { id: 'b', text: 'The lower throat', isCorrect: false },
      { id: 'c', text: 'The lips', isCorrect: false },
      { id: 'd', text: 'The middle of the tongue', isCorrect: false }
    ],
    explanation: 'The three letters of madd (wāw sākinah preceded by a ḍammah, yāʾ sākinah preceded by a kasrah, and alif) are pronounced from the empty space in the mouth and throat.',
    topic: 'taj101'
  },
  {
    id: 'taj034',
    text: 'Which letters are pronounced from the lower throat (closest to the chest)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Hamzah (ء)', isCorrect: true },
      { id: 'b', text: 'Hāʾ (ه)', isCorrect: true },
      { id: 'c', text: 'ʿAyn (ع)', isCorrect: false },
      { id: 'd', text: 'Ghayn (غ)', isCorrect: false }
    ],
    explanation: 'The hamzah (ء) and hāʾ (ه) are pronounced from the lower throat, which is the part of the throat closest to the chest and furthest from the opening of the mouth.',
    topic: 'taj101'
  },
  {
    id: 'taj035',
    text: 'Which letters are articulated from the middle throat?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'ʿAyn (ع)', isCorrect: true },
      { id: 'b', text: 'Ḥāʾ (ح)', isCorrect: true },
      { id: 'c', text: 'Khāʾ (خ)', isCorrect: false },
      { id: 'd', text: 'Ghayn (غ)', isCorrect: false }
    ],
    explanation: 'The ʿayn (ع) and ḥāʾ (ح) are pronounced from the middle throat.',
    topic: 'taj101'
  },
  {
    id: 'taj036',
    text: 'Which letters are pronounced from the upper throat (closest to the mouth)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Ghayn (غ)', isCorrect: true },
      { id: 'b', text: 'Khāʾ (خ)', isCorrect: true },
      { id: 'c', text: 'ʿAyn (ع)', isCorrect: false },
      { id: 'd', text: 'Qāf (ق)', isCorrect: false }
    ],
    explanation: 'The ghayn (غ) and khāʾ (خ) are pronounced from the upper throat, which is the part of the throat closest to the mouth.',
    topic: 'taj101'
  },
  {
    id: 'taj037',
    text: 'From which part of the tongue is the letter qāf (ق) pronounced?',
    type: 'single',
    options: [
      { id: 'a', text: 'The extreme back of the tongue touching the soft palate', isCorrect: true },
      { id: 'b', text: 'The center of the tongue', isCorrect: false },
      { id: 'c', text: 'The tip of the tongue', isCorrect: false },
      { id: 'd', text: 'The sides of the tongue', isCorrect: false }
    ],
    explanation: 'The qāf (ق) is pronounced from the extreme back of the tongue when touching the palate above it (the soft palate).',
    topic: 'taj101'
  },
  {
    id: 'taj038',
    text: 'Which part of the tongue is used to pronounce the kāf (ك)?',
    type: 'single',
    options: [
      { id: 'a', text: 'The back of the tongue touching the hard palate', isCorrect: true },
      { id: 'b', text: 'The extreme back of the tongue touching the soft palate', isCorrect: false },
      { id: 'c', text: 'The tip of the tongue', isCorrect: false },
      { id: 'd', text: 'The center of the tongue', isCorrect: false }
    ],
    explanation: 'The kāf (ك) is pronounced from the back of the tongue (not as far back as the qāf), when touching the palate above it (the hard palate).',
    topic: 'taj101'
  },
  {
    id: 'taj039',
    text: 'Which letters are pronounced from the center part of the tongue?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Jīm (ج)', isCorrect: true },
      { id: 'b', text: 'Shīn (ش)', isCorrect: true },
      { id: 'c', text: 'Yāʾ (unlengthened)', isCorrect: true },
      { id: 'd', text: 'Dāl (د)', isCorrect: false }
    ],
    explanation: 'The jīm (ج), shīn (ش), and the unlengthened yāʾ (اَلْيَاء غَيَر مَدِّيَّة) are pronounced from the center part of the tongue when touching the palate above it.',
    topic: 'taj101'
  },
  {
    id: 'taj040',
    text: 'What is meant by "yāʾ ghayr maddiyyah" (unlengthened yāʾ)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Yāʾ which is mutaḥarrikah (has a vowel)', isCorrect: true },
      { id: 'b', text: 'Yāʾ which is sākinah and preceded by a fatḥah', isCorrect: true },
      { id: 'c', text: 'Yāʾ which is sākinah and preceded by a kasrah', isCorrect: false },
      { id: 'd', text: 'Yāʾ which is at the end of a word', isCorrect: false }
    ],
    explanation: 'The yāʾ ghayr maddiyyah (unlengthened yāʾ) is either that yāʾ which is mutaḥarrikah (has a vowel) or which is sākinah and preceded by a fatḥah. The latter is also called yāʾ līn (يَيْ).',
    topic: 'taj101'
  }
];
